import { taskImportantAriaText } from './TodoStarCharm.locstring.json';
import { observer } from 'mobx-react-lite';
import loc from 'owa-localize';
import { StarCharm } from 'owa-star-charm';
import * as React from 'react';
import {
    markAsImportantLabel,
    removeImportanceLabel,
} from './CommonTodoViewStrings.locstring.json';

export interface TodoStarCharmProps {
    onClick: () => void;
    isImportant: boolean;
    style: string;
    iconStyles: string;
}

export default observer(function TodoStarCharm(props: TodoStarCharmProps) {
    const { onClick, isImportant, style, iconStyles } = props;

    const onClickCallback = React.useCallback(
        (evt: React.MouseEvent<EventTarget>) => {
            evt.stopPropagation();
            onClick();
        },
        [onClick]
    );

    return (
        <StarCharm
            isStarred={isImportant}
            onClick={onClickCallback}
            iconStyles={iconStyles}
            ariaLabelText={loc(taskImportantAriaText)}
            tooltip={{
                starred: loc(removeImportanceLabel),
                unstarred: loc(markAsImportantLabel),
            }}
            buttonStyles={style}
        />
    );
});
